import { render, staticRenderFns } from "./AddIncentive.vue?vue&type=template&id=50581abf"
import script from "./AddIncentive.vue?vue&type=script&lang=js"
export * from "./AddIncentive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports